import { startSyntheticDataDemoStreamLoop } from './syntheticDataDemoStreamLoop.js'
import { updatePendingSyntheticDataDemoMessage } from './patchSyntheticDataDemoMessage.js'

/** @param {import('./runB2bCopilotPlanDemoStream.js').B2bStreamCtx} ctx */
export function runSyntheticDataDemoStream(ctx) {
  updatePendingSyntheticDataDemoMessage(ctx.setMessagesByThreadId, ctx.tid, ctx.pendingId, {
    demoStreamActive: true,
  })
  startSyntheticDataDemoStreamLoop(ctx)
}
